import Fetch from '../Fetch';

export default {
  queryNeighbor: (params) => {
    return Fetch.get(`/api/v1/neighbor`, { params });
  },
};
